import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { RatingItem } from 'pkg/api/models/rating_item';
import type { Record } from 'pkg/api/models/record';
import type { User } from 'pkg/api/models/user';

export enum UserActivityType {
	Individual = 'individual',
	Group = 'group',
	Match = 'match',
	Other = 'other',
}

export enum StrainLevel {
	Max = 'max',
	VeryHigh = 'veryHigh',
	High = 'high',
	Moderate = 'moderate',
	Low = 'low',
	VeryLow = 'veryLow',
}

export interface PhysicalStrainStats {
	physicalStrain: number;
	strainLevel: StrainLevel;
}

export interface UserActivity extends Record, Dateable, AllowedActionable {
	ratingItemId?: number;
	userId?: number;
	user: User;

	description?: string;
	privateComment?: string;

	physicalStrain: number;
	completedAt: number;
	type: UserActivityType;
	ratingItem: RatingItem;
}

export enum PhysicalStrainThreshold {
	Max = 100,
	VeryHigh = 90,
	High = 70,
	Moderate = 40,
	Low = 20,
}
